module.exports = __webpack_public_path__ + "static/img/companyBackground1.5a6011dd.png";